import apiClient from "../../utils/request";

/**
 * 获取项目列表
 */
export const getProjectList = async ({search}) => 
    await apiClient.get("/api/project/list",{search});

/**
 * 创建项目
 */
export const createProject = async ({ name, bgColor,designStandard,data }) =>
    await apiClient.post("/api/project", { name, bgColor,designStandard,data });

/**
 * 删除项目
 */
export const deleteProject = async ({ id }) =>
    await apiClient.delete(`/api/project/${id}`,{});

/**
 * 保存项目
 */

export const saveProject = async ({ id, data }) =>
    await apiClient.post(`/api/project/${id}`, { data });